import apiClient from './apiClient';

export const vehicleApi = {
    // Vehicles
    getVehicles: async () => {
        const response = await apiClient.get('/api/vehicles');
        return response.data;
    },
    createVehicle: async (data) => {
        const response = await apiClient.post('/api/vehicles', data);
        return response.data;
    },
    updateVehicle: async (id, data) => {
        const response = await apiClient.put(`/api/vehicles/${id}`, data);
        return response.data;
    },
    deleteVehicle: async (id) => {
        const response = await apiClient.delete(`/api/vehicles/${id}`);
        return response.data;
    },

    // Documents
    getVehicleDocuments: async (vehicleId) => {
        const response = await apiClient.get(`/api/vehicles/${vehicleId}/documents`);
        return response.data;
    },
    uploadDocument: async (vehicleId, formData) => {
        const response = await apiClient.post(`/api/vehicles/${vehicleId}/documents`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },
    deleteDocument: async (vehicleId, docId) => {
        const response = await apiClient.delete(`/api/vehicles/${vehicleId}/documents/${docId}`);
        return response.data;
    },

    // Categories
    getCategories: async () => {
        const response = await apiClient.get('/api/vehicles/categories');
        return response.data;
    },
    createCategory: async (data) => {
        const response = await apiClient.post('/api/vehicles/categories', data);
        return response.data;
    },
    updateCategory: async (id, data) => {
        const response = await apiClient.put(`/api/vehicles/categories/${id}`, data);
        return response.data;
    },
    deleteCategory: async (id) => {
        const response = await apiClient.delete(`/api/vehicles/categories/${id}`);
        return response.data;
    },
    getCategoryVehicleCount: async (id) => {
        const response = await apiClient.get(`/api/vehicles/categories/${id}/count`);
        return response.data;
    }
};
